export const LoadingSpinner = ({ message = 'Loading...' }) => (
  <div className='text-center '>
    <div className='inline-flex items-center'>
      <div className='animate-spin rounded-full h-6 w-6 border-b-2 border-indigo-600 ' />
      <p className='text-gray-500 text-lg'>{message}</p>
    </div>
  </div>
)
